import { updateEmployee } from "api/Employee";
import { UseMutationOptions, useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";


export const useUpdateEmployee = (
options?: UseMutationOptions<any, any, any, unknown>
) => {
    const queryClient = useQueryClient();
    return useMutation(updateEmployee, {
        onSuccess: () => {
            toast.success("Employee updated successfully!");
            queryClient.invalidateQueries('coustomers')
            queryClient.invalidateQueries('employes-profile')
            
        },
        onError: () => {
            toast.error("Employee update failed! Please try again later.");
        },
        ...options
    })
}